import React, {useState} from 'react';

import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Form,
    FormGroup,
    Input,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row, Table
} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {RotateCircleLoading} from "react-loadingg";
import classnames from "classnames";
import {resource_strings} from "../../translations/resource_translations";
import dateHelpers from "../../helpers/DateHelper";
import ResourceItem from "../Lists/ResourceItem";
import CheckBoxList from "../Tables/CheckBoxList";
import ClassApiService from "../../api/classes-api-service";

let alertStrings = new LocalizedStrings(alert_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const AddClassModal = (props) => {
    const [visible, setVisible] = useState(true);
    const [showClasses, setShowClasses] = useState(false);
    const [navPills, setNavPills] = useState(1);
    const [startValid, setStartValid] = useState(true);
    const [endValid, setEndValid] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedClassTypes, setSelectedClassTypes] = useState(null);
    const [unSelectedClassTypes, setUnSelectedClassTypes] = useState([]);
    const classTypes = props.classTypes;
    const [updateNow, setUpdateNow] = useState(true);
    const [selectedStart, setSelectedStart] = useState(dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()));
    const [selectedEnd, setSelectedEnd] = useState(dateHelpers.databaseDate(dateHelpers.lastDayOfMonth()));

    const updateFunc = () => {
        setUpdateNow(!updateNow)
    };

    const onDismiss = () => setVisible(false);

    function toggle(formModal) {
        setVisible(!visible);
        props.toggleModal();
    }

    function toggleClasses(formModal) {
        setShowClasses(!showClasses);
    }


    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    };

    const handleDateChange = (event) => {
        if (event.target.id === "input-start") {
            setSelectedStart(event.target.value);
        } else {
            setSelectedEnd(event.target.value);
        }

        //validateDates()
    };

    const toggleNavs = (e, index) => {
        e.preventDefault();

        setNavPills(index);
    };

    const validationCleared = () => {
        return true
    };

    localize();

    function closeClassTypesSelector(e) {
        e.preventDefault();

        toggleClasses()
    };

    function selectAll(all) {

        if (all) {
            setSelectedClassTypes(classTypes);
            updateFunc()
        }
        else {
            setSelectedClassTypes([]);
            updateFunc()
        }
    }

    function selectAllClassTypes(e) {
        e.preventDefault();
        selectAll(true)
    };

    function deselectAllClassTypes(e) {
        e.preventDefault();
        selectAll(false)
    };

    function renderCTable() {
        if (selectedClassTypes === null) {
            setSelectedClassTypes(classTypes)
        } else {

            const selected = selectedClassTypes.map(it => it.id);
            return (props.classTypes).concat(unSelectedClassTypes).map((tt, index) => {

                return (
                    <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                                  selected={selected.includes(tt.id)}
                                  handleChange={handleCTSelected}/>
                )
            })
        }
    };

    function handleCTSelected(checked, id) {
        const tt = classTypes.find(it => it.id === id);
        const selectedIds = ((selectedClassTypes) ? selectedClassTypes : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selectedClassTypes.push(tt);
                    setSelectedClassTypes(selectedClassTypes);
                    updateFunc()
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const arr = [];
                    for (let i = 0; i < selectedClassTypes.length; i++) {
                        if (tt.id !== selectedClassTypes[i].id) {
                            arr.push(selectedClassTypes[i]);
                        }
                    }
                    setSelectedClassTypes(arr);
                    updateFunc();
                }
            }
        }
    }

    function deleteClasses(e) {
        setIsLoading(true);
        e.preventDefault();

        ClassApiService
            .deleteClasses(selectedStart, selectedEnd, selectedClassTypes ? selectedClassTypes.map(it => it.id).join(",") : null)
            .then(res => {
                setIsLoading(false);

                props.handleClassesAdded(res)
            })
            .catch((e) => {
                props.handleError(e)
            });
    }

    function postRegularClasses(e) {
        setIsLoading(true);
        e.preventDefault();

        ClassApiService
            .addRegular(selectedStart, selectedEnd, selectedClassTypes ?
                selectedClassTypes.map(it => it.id).join(",") : null)
            .then(res => {
                setIsLoading(false);

                props.handleClassesAdded(res)
            })
            .catch((e) => {
                props.handleError(e)
            });
    }

    return (
        <Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-danger"
            isOpen={visible}
            toggle={() => toggle("notificationModal")}
        >

            {showClasses === true &&
            <Modal
                className="modal-dialog-centered modal-danger"
                contentClassName="bg-gradient-danger"
                isOpen={visible}
                toggle={() => toggleClasses("notificationModal")}
            >
                <Card className="bg-secondary shadow">
                    <CardHeader className="bg-white border-0">
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">{resourceStrings.manage_ct}</h3>
                            </Col>
                            {classTypes && (classTypes.length === 0) &&
                            <div>
                                {resourceStrings.no_ct}
                            </div>
                            }
                            <div className="col text-right">
                                <Button
                                    color="warning"
                                    onClick={e => closeClassTypesSelector(e)}
                                    size="sm"
                                >
                                    {commonStrings.close}
                                </Button>
                            </div>
                        </Row>

                        <Row className="align-items-center">
                            <Col>
                                <Button
                                    color="success"
                                    onClick={e => selectAllClassTypes(e)}
                                    size="sm"
                                >
                                    {commonStrings.select_all}
                                </Button>

                                <Button
                                    color="info"
                                    onClick={e => deselectAllClassTypes(e)}
                                    size="sm"
                                >
                                    {commonStrings.deselect_all}
                                </Button>
                            </Col>
                        </Row>

                    </CardHeader>
                    <CardBody>
                        <Table
                            className="align-items-center table-dark table-flush mt-2"
                            responsive
                        >
                            <thead className="thead-dark">
                            <tr>
                                <th scope="col"/>
                            </tr>
                            </thead>
                            <tbody>
                            {renderCTable()}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Modal>}


            <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {isLoading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <Row className="align-items-center">
                        <div className="col">
                            <h2 className="text-white mb-0">{resourceStrings.manage_classes}</h2>
                        </div>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => toggle("notificationModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Nav
                        className="nav-fill flex-column flex-sm-row"
                        id="tabs-text"
                        pills
                        role="tablist"
                    >
                        <NavItem>
                            <NavLink
                                aria-selected={navPills === 1}
                                className={classnames("mb-sm-3 mb-md-0", {
                                    active: navPills === 1
                                })}
                                onClick={e => toggleNavs(e, 1)}
                                href="#pablo"
                                role="tab"
                            >
                                {resourceStrings.add_regular_classes}
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                aria-selected={navPills === 2}
                                className={classnames("mb-sm-3 mb-md-0", {
                                    active: navPills === 2
                                })}
                                onClick={e => toggleNavs(e, 2)}
                                href="#pablo"
                                role="tab"
                            >
                                {resourceStrings.delete_classes}
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <div style={{marginTop: 18}}>
                        <small>{navPills === 1 ? resourceStrings.add_regular_classes_expl : resourceStrings.delete_classes_expl}</small>
                    </div>
                    <hr style={{backgroundColor: "white"}}/>

                    <Form>
                        <div className="pl-lg-12">

                            <Row>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-start"
                                        >
                                            {commonStrings.from}
                                        </label>
                                        <Input
                                            className={startValid === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={handleDateChange}
                                            defaultValue={selectedStart}
                                            id="input-start"
                                            type="date"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-end"
                                        >
                                            {commonStrings.until}
                                        </label>
                                        <Input
                                            className={endValid === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={handleDateChange}
                                            defaultValue={selectedEnd}
                                            id="input-end"
                                            type="date"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12" className="text-center">
                                    <Button
                                        color="secondary"
                                        disabled={!validationCleared()}
                                        outline="button"
                                        size="sm"
                                        type="button"
                                        onClick={e => setShowClasses(true)}
                                    >
                                        {resourceStrings.manage_ct}
                                    </Button>
                                </Col>
                            </Row>

                            {selectedClassTypes &&
                            <div className="text-center">
                                <small>
                                    ({selectedClassTypes.length}) selected
                                </small>
                            </div>
                            }

                            <Row>
                                <Col lg="12" className="text-right">
                                    <Button
                                        color={navPills === 1 ? "primary" : "danger"}
                                        disabled={!validationCleared()}
                                        type="button"
                                        size="lg"
                                        onClick={navPills === 1 ? postRegularClasses : deleteClasses}
                                    >
                                        {navPills === 1 ? commonStrings.add : commonStrings.delete}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Modal>
    );
};

export default AddClassModal;